import { Component, inject } from "@angular/core";
import { CURRENT_TAB_FACTORY } from "src/app/tokens/current-tab.token";
import {
  PAGE_DATAGRID_TAB_SHELL,
  PageDatagridTabShellContext
} from "src/app/tokens/page-datagrid-tab-shell.token";

@Component({
  standalone: false,
  selector: "pms-page-datagrid-tab-shell",
  template: `
    <div class="flex flex-col flex-1">
      <ng-content></ng-content>
    </div>
  `,
  styles: `
    :host {
      display: flex;
      flex: 1;
    }
  `,
  providers: [
    {
      provide: PAGE_DATAGRID_TAB_SHELL,
      useFactory: (): PageDatagridTabShellContext => {
        return {
          tab: inject(CURRENT_TAB_FACTORY)()
        };
      }
    }
  ]
})
export class PageDatagridTabShellComponent {}
